import React from 'react';
import { withTranslate } from 'react-redux-multilingual';


function Vi(props) {
    const { translate } = props;
    return (
        <div className="wrap">
            <h1>Chính sách bảo mật</h1>
            <div>
                <div className="contents">
                    <div name="gioithieu">
                        <h2>Giới thiệu</h2>
                        <p>Chào mừng bạn đã đến với website của RPA CLOUD (gọi chung là “chúng tôi” hoặc “của chúng tôi”).
                        </p>
                        <p>Chính sách bảo mật này được thiết kế để giúp bạn hiểu được cách thức chúng tôi thu thập,
                            sử dụng, tiết lộ và/hoặc xử lý dữ liệu cá nhân mà bạn đã cung cấp cho chúng tôi
                            và/hoặc lưu giữ về bạn, cho dù là hiện nay hoặc trong tương lai,
                            cũng như để giúp bạn đưa ra quyết định sáng suốt trước khi cung cấp
                            cho chúng tôi bất kỳ dữ liệu cá nhân nào của bạn.
                        </p>
                        <p>
                            Chúng tôi nghiêm túc thực hiện trách nhiệm của mình liên quan đến bảo mật thông tin
                            theo các quy định về bảo vệ bí mật thông tin cá nhân của pháp luật Việt Nam (“Luật riêng tư”)
                            và cam kết tôn trọng quyền riêng tư và sự quan tâm của tất cả người dùng đối dịch vụ của
                            chúng tôi.
    
                        </p>
                        <p>
                            Vì lợi ích của chính bạn, vui lòng đọc kĩ các điều khoản trong chính sách bảo mật này
                            trước khi truy cập hoặc sử dụng bất kì dịch vụ nào của chúng tôi
    
                        </p>
                        <p>
                            Bằng việc sử dụng Các Dịch Vụ, đăng ký một tài khoản với chúng tôi hoặc truy cập Nền tảng,
                            bạn xác nhận và đồng ý rằng bạn chấp nhận các phương pháp, yêu cầu, và/hoặc chính sách được
                            mô tả trong Chính sách bảo mật này, và theo đây bạn đồng ý cho phép chúng tôi thu thập,
                            sử dụng, tiết lộ và/hoặc xử lý dữ liệu cá nhân của bạn như mô tả trong đây.
                            <strong>NẾU BẠN KHÔNG ĐỒNG Ý CHO PHÉP XỬ LÝ DỮ LIỆU CÁ NHÂN CỦA BẠN NHƯ MÔ TẢ TRONG CHÍNH SÁCH NÀY,
                            VUI LÒNG KHÔNG SỬ DỤNG CÁC DỊCH VỤ CỦA CHÚNG TÔI HAY TRUY CẬP NỀN TẢNG HOẶC
                            TRANG WEB CỦA CHÚNG TÔI</strong>. Nếu chúng tôi thay đổi Chính sách bảo mật của mình,
                            chúng tôi sẽ thông báo cho bạn bao gồm cả thông qua việc đăng tải những thay đổi đó
                            hoặc Chính sách bảo mật sửa đổi trên Nền tảng của chúng tôi. Trong phạm vi pháp luật
                            cho phép, việc tiếp tục sử dụng các Dịch Vụ hoặc Nền Tảng, bao gồm giao dịch của bạn,
                            được xem là bạn đã công nhận và đồng ý với các thay đổi trong Chính Sách Bảo Mật này.
    
                        </p>
                        <p>Trang web được kiểm soát và vận hành bởi RPA CLOUD.</p>
                    </div>
                    <div name="d1">
                        <h2>Điều 1. Định nghĩa</h2>
                        <p>
                            Định nghĩa của các thuật ngữ trong văn bản này như sau:
                        </p>
                        <div>
                            <ol>
                                <li>
                                    <span className="bold-style">Người dùng:</span>
                                    <br/>
                                    Người đăng ký tài khoản với chúng tôi để sử dụng Dịch Vụ
                                </li>
                                <li>
                                    <span className="bold-style">Dữ liệu cá nhân:</span>
                                    <br/>
                                    Có nghĩa là dữ liệu, dù đúng hay không,
                                    về một cá nhân mà thông qua đó có thể được xác định được danh tính, hoặc từ dữ liệu đó
                                    và thông tin khác mà một tổ chức có hoặc có khả năng tiếp cận. Các ví dụ thường gặp về
                                    dữ liệu cá nhân có thể gồm có tên, thông tin liên hệ.
    
                                </li>
                            </ol>
                        </div>
    
                    </div>
                    <div name="d2">
                        <h2>Điều 2. Mục đích và phạm vi thu thập</h2>
                        <p>Chúng tôi thu thập một số thông tin nhất định được liệt kê dưới đây
                            của khách hàng khi khách hàng sử dụng Dịch vụ hoặc khi khách hàng
                            liên hệ trực tiếp với chúng tôi thông qua các biểu mẫu liên lạc
                            trên website. Chúng tôi chỉ thu thập thông tin cần thiết để có thể
                            cung cấp dịch vụ cho khách hàng.
                        </p>
                        <ol>
                            <li>
                                <span className="bold-style">Địa chỉ email:</span>
                                <br/>
                                Địa chỉ e-mail của khách hàng sẽ được sử dụng để nhận dạng
                                với tư cách là người dùng trong dịch vụ này, cũng như là phương
                                tiện liên lạc chính về các chính sách bảo mật, điều khoản sử dụng,
                                bổ sung các chức năng của dịch vụ này, các thay đổi của dịch vụ này
                                và các câu hỏi từ khách hàng. Chúng tôi cũng có thể sử dụng địa chỉ
                                email của khách hàng để liên hệ cho các mục đích tiếp thị.
                                Chúng tôi sẽ cung cấp thông tin hữu ích cho khách hàng,
                                khách hàng có thể hủy các email tiếp thị về sản phẩm và dịch vụ
                                bất kỳ lúc nào. Email của khách hàng được giữ an toàn và được
                                mã hóa trong cơ sở dữ liệu của chúng tôi.
    
                            </li>
                            <li>
                                <span className="bold-style">Họ tên:</span>
                                <br/>
                                Họ tên được sử dụng để định danh và xưng hô khi chúng tôi liên lạc với khách hàng và được mã
                                hóa trong cơ sở dữ liệu của chúng tôi.
                            </li>
                            <li>
                                <span className="bold-style">Những dịch vụ liên kết dưới đây:
                                </span>
                                <ol>
                                    <li className="serial-number">Gmail</li>
                                    <li className="serial-number">Google Spreadsheet</li>
                                    <li className="serial-number">Google Drive</li>
                                    <li className="serial-number">Google Calendar</li>
                                    <li className="serial-number">AWS S3</li>
                                    <li className="serial-number">Filemaker</li>
                                    <li className="serial-number">Cloudsign</li>
                                </ol>
                                <p>Những thông tin đăng nhập liên kết cũng sẽ được mã hóa trong cơ sở dữ liệu của chúng tôi.
                                </p>
                            </li>
                            <li>
                                <span className="bold-style">Địa chỉ IP:</span>
                                <br/>
                                Dịch vụ này dựa trên kết nối với internet. Địa chỉ IP nguồn kết nối
                                của bạn là số nhận dạng khi kết nối với Internet và dịch vụ này ghi
                                lại địa chỉ IP cho mục đích bảo mật và khắc phục sự cố.
                            </li>
                            <li>
                                <span className="bold-style">Thiết bị, phiên bản phần mềm mà khách hàng sử dụng:</span>
                                <br/>
                                Thông tin này là cần thiết để giải quyết các vấn đề khi phát sinh lỗi với các phiên bản ứng
                                dụng và thiết bị cụ thể.
                            </li>
                            <li>
                                <span className="bold-style">Thông tin hoạt động của khách hàng khi sử dụng dịch vụ này:</span>
                                <br/>
                                Chúng tôi phân tích các hình thức sử dụng của dịch vụ này và thu thập thông tin sử dụng nhằm
                                mục đích cải thiện dịch vụ này.
                                Thông tin này không bao gồm thông tin liên hệ hoặc dữ liệu cá nhân của khách hàng.
                            </li>
                            <li>
                                <span className="bold-style">Lịch sử sử dụng dịch vụ:</span>
                                <br/>
                                Chúng tôi thu thập thông tin lịch sử, bao gồm lịch sử truy cập máy chủ,
                                để ngăn chặn gian lận và truy cập trái phép.
                                Thông tin lịch sử ghi lại các thông tin như địa chỉ IP,
                                nơi truy cập, ngày và giờ truy cập, hệ điều hành,
                                thiết bị được sử dụng, trình duyệt được sử dụng,
                                quy trình làm việc và tác vụ được thực thi.
                                Thông tin này sẽ được sử dụng để cải thiện tính bảo mật của Dịch vụ,
                                điều tra khi có sự cố xảy ra và khi cần thiết.
    
                            </li>
                            <li>
                                <span className="bold-style">Kết quả thực thi của dịch vụ: </span>
                                <br/>
                                Chúng tôi thu thập nhật ký thực hiện quy trình làm việc
                                để xem kết quả tự động hóa của khách hàng.
                                Chúng tôi sẽ không xem lịch sử thực hiện quy trình làm việc
                                mà không có yêu cầu của khách hàng hoặc sự chấp thuận trước
                                của khách hàng, đặc biệt là trong các trường hợp khẩn cấp
                                như khủng hoảng bảo mật hoặc sự cố hoặc theo quy định của pháp luật.
                            </li>
                            <li>
                                <span className="bold-style">Thông tin cookie:</span>
                                <br/>
                                "Cookie" là các mã danh định được lưu trữ trên máy tính hoặc thiết bị di
                                động của bạn lưu trữ các dữ liệu về máy tính hoặc thiết bị, bằng cách nào và khi nào Các
                                Dịch Vụ hoặc Nền tảng được sử dụng hay truy cập, bởi bao nhiêu người và để theo dõi những
                                hoạt động trong Các Nền tảng của chúng tôi.
                                <br/>
                                Chúng tôi có thể liên kết thông tin cookie với dữ liệu cá nhân.
                                Thông tin này là bắt buộc để xác định khách hàng là người dùng
                                duy nhất có quyền truy cập vào thông tin của chính khách hàng
                                và để ngăn những người dùng khác không có quyền truy cập trái phép.
                                Thông tin cookie được lưu trữ trong trình duyệt của khách hàng.
                                <br/>
                                Bạn có thể từ chối sử dụng cookie bằng cách chọn các thiết lập
                                thích hợp trên trình duyệt hoặc thiết bị của bạn.
                                Tuy nhiên, vui lòng lưu ý rằng nếu bạn thực hiện thao
                                tác này bạn có thể không sử dụng được các chức năng đầy
                                đủ của Nền tảng hoặc Các Dịch Vụ của chúng tôi.
                            </li>
                        </ol>
                    </div>
                    <div name="d3">
                        <h2>Điều 3. Phạm vi sử dụng thông tin
                        </h2>
                        <p>Chúng tôi cam kết chỉ sử dụng thông tin trong nội bộ theo đúng những mục đích đã đề nêu ở Điều 2
                        </p>
                        <p>Ngoài ra, Bạn xác nhận, cho phép và đồng ý rằng chúng tôi có thể truy cập,
                            lưu trữ và tiết lộ thông tin Tài khoản và Nội dung của bạn nếu luật pháp
                            yêu cầu làm như vậy hoặc theo lệnh của tòa án hoặc của bất kỳ cơ quan
                            chính phủ hoặc cơ quan quản lý nào có thẩm quyền đối với RPA CLOUD hoặc
                            với lý do chính đáng RPA CLOUD tin rằng việc truy cập, lưu giữ hoặc tiết lộ đó là cần thiết và chính đáng để:
                        <ol>
                            <li className="serial-number">Tuân thủ quy trình pháp lý</li>
                            <li className="serial-number">Tuân thủ yêu cầu từ bất kỳ cơ quan chính phủ hoặc cơ quan quản lý nào có thẩm quyền đối với RPA CLOUD</li>
                            <li className="serial-number">Thực thi Điều khoản Dịch vụ của chúng tôi hoặc Chính sách Bảo mật này</li>
                            <li className="serial-number">Phản hồi bất kỳ khiếu nại nào du cho là nguy cơ hoặc đang xảy ra trên thực tế để chống lại RPA CLOUD hoặc các chi nhánh có liên quan hoặc khiếu nại khác rằng bất kỳ nội dung nào vi phạm quyền của bên thứ ba</li>
                            <li className="serial-number">Đáp ứng các yêu cầu của bạn về dịch vụ khách hàng</li>
                            <li className="serial-number">Bảo vệ quyền, tài sản hoặc sự an toàn cá nhân của RPA CLOUD</li>
                        </ol>
                        </p>
                        <p>
                            Vì Các Mục Đích mà chúng tôi sẽ/có thể thu thập, sử dụng,
                            tiết lộ hoặc xử lý dữ liệu cá nhân của bạn phụ thuộc vào hoàn cảnh hiện có,
                            mục đích đó có thể không xuất hiện bên trên. Tuy nhiên, chúng tôi sẽ thông báo cho bạn biết mục
                            đích khác đó tại thời điểm xin sự cho phép của bạn, trừ phi việc xử lý dữ liệu áp dụng mà không
                            có sự đồng ý của bạn là được phép theo các quy định của pháp luật về bảo vệ bí mật thông tin cá
                            nhân hoặc theo quy định pháp luật.
                        </p>
    
                    </div>
                    <div name="d4">
                        <h2>Điều 4. Hình thức bảo về và lưu trữ thông tin</h2>
                        <p>Tất cả những thông tin chúng tôi lưu trữ đã nêu ở
                            Điều 2 sẽ được chúng tôi thực hiện việc mã hóa và
                            lưu trên hệ thống của chúng tôi
                        </p>
                        <p>Dữ liệu cá nhân của người dùng được lưu trữ đằng sau các mạng bảo mật
                            và chỉ có thể được truy cập bởi một số nhân viên có quyền truy
                            cập đặc biệt đến các hệ thống của chúng tôi. Tuy nhiên,
                            chắc chắn không thể có sự đảm bảo an ninh tuyệt đối.
                        </p>
                    </div>
                    <div name="d5">
                        <h2>Điều 5. Thời gian lưu trữ thông tin</h2>
                        <p>Chúng tôi sẽ lưu trữ các Thông tin cá nhân do Khách hàng cung cấp trên các hệ thống nội bộ của
                            chúng tôi trong quá trình cung cấp dịch vụ cho Khách hàng hoặc cho đến khi hoàn thành mục đích
                            thu thập hoặc khi Khách hàng có yêu cầu hủy các thông tin đã cung cấp. Tùy thuộc vào quy định
                            của pháp luật, chúng tôi có thể tiêu hủy dữ liệu cá nhân của bạn một cách an toàn mà không cần
                            thông báo trước cho bạn.
    
                        </p>
                    </div>
                    <div name="d6">
                        <h2>Điều 6. Tiết lộ thông tin khách hàng </h2>
                        <p>Thông tin của khách hàng được cam kết bảo mật tuyệt đối theo chính sách bảo vệ thông tin cá nhân
                            . Việc thu thập và sử dụng thông tin của mỗi khách hàng chỉ được thực hiện khi có sự đồng ý của
                            khách hàng đó , trừ trường hợp buộc phải cung cấp khi Cơ quan chức năng yêu cầu.Không sử dụng,
                            không chuyển giao, cung cấp hay tiết lộ cho bên thứ 3 nào về thông tin cá nhân của thành viên
                            khi không có sự cho phép đồng ý từ thành viên.
                        </p>
                        <p>Hơn nữa, chúng tôi cam kết rằng chúng tôi sẽ không chia sẻ bất kỳ dữ liệu người dùng nào với bất kỳ công cụ AI nào.</p>
                        <p>
                            RPA CLOUD tuân thủ Chính sách dữ liệu người dùng Dịch vụ API của Google, đảm bảo tuân thủ các yêu cầu Sử dụng có giới hạn. Chúng tôi cam kết không sử dụng dữ liệu của khách hàng cho các mục đích vượt quá phạm vi dịch vụ của chúng tôi.
                            Để biết thêm chi tiết, vui lòng tham khảo Chính sách dữ liệu người dùng <a target='blank' href='https://developers.google.com/terms/api-services-user-data-policy'>Dịch vụ API của Google</a>.
                        </p>
                        <p>
                            Trong trường hợp máy chủ lưu trữ thông tin bị hacker tấn công dẫn đến mất mát dữ liệu cá nhân
                            thành viên, ban quản trị website sẽ có trách nhiệm thông báo vụ việc cho cơ quan chức năng điều
                            tra xử lý kịp thời và thông báo cho thành viên được biết.
                        </p>
                        <p>Trong trường hợp khách hàng phát hiện thông tin cá nhân bị sử dụng sai mục đích hoặc bị xâm phạm
                            thì khách hàng có thể gửi khiếu nại thông qua kênh chăm sóc khách hàng của chúng tôi, khi nhận
                            được các thông tin khiếu nại của thành viên, chúng tôi sẽ dùng mọi biện pháp cần thiết để ngăn
                            chặng không cho thông tin cá nhân đó bị tiếp tục xâm phạm, đồng thời có các biện pháp hỗ trợ để
                            bảo vệ quyền và lợi ích hợp pháp của khách hàng.Khách hàng có quyền gửi khiếu nại về việc lộ
                            thông tin cá nhân cho bên thứ 3 đến Ban quản trị của website. Khi tiếp nhận những phản hồi này,
                            chúng tôi sẽ xác nhận lại thông tin, phải có trách nhiệm trả lời lý do và hướng dẫn thành viên
                            khôi phục và bảo mật lại thông tin.
                        </p>
                    </div>
                    <div name="d7">
                        <h2>Điều 7. Loại trừ trách nhiệm về nghĩa vụ bảo mật và các trang web bên thứ ba
                        </h2>
                        <p>
                            Nhằm cung cấp cho bạn giá trị gia tăng, chúng tôi có thể chọn các trang web hoặc ứng dụng hoặc
                            dịch vụ của bên thứ ba khác nhau để liên kết, và đóng khung bên trong Nền tảng. Chúng tôi cũng
                            có thể tham gia các quan hệ cùng tiếp thị và các quan hệ khác để cung cấp dịch vụ thương mại
                            điện tử và các dịch vụ và tính năng khác cho khách truy cập. Những trang được liên kết này có
                            các chính sách về quyền riêng tư cũng như các biện pháp bảo mật riêng và độc lập. Ngay cả khi
                            bên thứ ba đó có liên kết với chúng tôi, chúng tôi cũng không kiểm soát các trang web/ứng
                            dụng/dịch vụ được liên kết này, mỗi trang đó có các phương pháp bảo vệ quyền riêng tư và thu
                            thập dữ liệu riêng biệt, độc lập với chúng tôi. Dữ liệu thu thập bởi các đối tác cùng tiếp thị
                            của chúng tôi hoặc các trang web/ứng dụng/dịch vụ của bên thứ ba (ngay cả khi được cung cấp trên
                            hoặc thông qua Nền tảng của chúng tôi) có thể không được chúng tôi tiếp cận và/hoặc lưu giữ.
                        </p>
                        <p>
                            Do đó chúng tôi không chịu trách nhiệm hay trách nhiệm pháp lý đối với nội dung, các biện pháp
                            bảo mật (hoặc sự thiếu biện pháp bảo mật) và các hoạt động của các trang web/ứng dụng/dịch vụ
                            được liên kết này. Những trang web/ứng dụng/dịch vụ được liên kết này chỉ vì sự thuận tiện cho
                            bạn và do đó bạn tự chịu trách nhiệm khi truy cập chúng. Tuy nhiên, chúng tôi tìm cách bảo vệ
                            tính toàn vẹn của Nền tảng của chúng tôi và các liên kết được đặt trên từng trang web đó và do
                            đó chúng tôi hoan nghênh ý kiến phản hồi về các trang web được liên kết này (bao gồm nếu một
                            trang web cụ thể không hoạt động).
                        </p>
                    </div>
                    <div name="d8">
                        <h2>Điều 8. Phạm vi sử dụng thông tin
                        </h2>
                        <p>Bạn có thể liên lạc với chúng tôi tại địa chỉ <strong>support@rpa-cloud.io</strong> trong trường hợp sau:
                        </p>
    
                        <ol>
                            <li className="serial-number">Bạn muốn rút lại sự đồng ý cho phép thu thập, sử dụng và/hoặc tiết lộ và/hoặc
                                yêu cầu xóa dữ liệu cá nhân của bạn mà chúng tôi đang lưu giữ
                            </li>
                            <li className="serial-number">Khi bạn có bất kỳ thắc mắc hoặc khiếu nại nào về các phương pháp bảo vệ quyền
                                riêng tư của chúng tôi
                            </li>
                            <li className="serial-number">Khi bạn muốn thay đổi chỉnh sửa thông tin cá nhân
                            </li>
                        </ol>
                        <p>
                            Tuy nhiên, Chúng tôi bảo lưu quyền từ chối sửa dữ liệu cá nhân của bạn theo các quy định của
                            pháp luật về bảo vệ bí mật thông tin cá nhân, trường hợp các điều luật đó yêu cầu và/hoặc cho
                            phép một tổ chức từ chối sửa dữ liệu cá nhân trong các trường hợp như thế.
    
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
    export default withTranslate(Vi);